/* The displayed design is the source of truth. This module never changes print
 * placement, selectedDesignUrl, cart metadata, uploads, or persisted assets. */
(function () {
  'use strict';
  const $ = selector => document.querySelector(selector);
  const profiles = {
    'iPhone 16 Pro': { file: '16pro.png', panel: [203, 340, 1010, 2070] },
    'iPhone 16 Pro Max': { file: '16proM.png', panel: [161, 258, 1040, 2144] },
    'iPhone 17 Pro': { file: '17pro.png', panel: [172, 832, 1023, 2125], renderer: 'iphone-17-pro' },
    'iPhone 17 Pro Max': { file: '17PM.png', panel: [146, 740, 1060, 2164], renderer: 'iphone-17-pro-max' },
    // Owner-requested reuse, matching phone-mockup-map.liquid's existing 18 aliases.
    'iPhone 18 Pro': { name: 'iPhone 18 Pro', file: '17pro.png', panel: [172, 832, 1023, 2125], renderer: 'iphone-17-pro' },
    'iPhone 18 Pro Max': { name: 'iPhone 18 Pro Max', file: '17PM.png', panel: [146, 740, 1060, 2164], renderer: 'iphone-17-pro-max' }
  };
  const rendererLoads = new Map();
  let viewer, viewerProfile, canvas, stage, flat, observer, resizeObserver, timer;
  let revision = 0, opened = false, mode = 'flat', wanted = false, lastModel = '';
  let lastSignature = null;
  const imageCache = new Map();
  const config = () => JSON.parse($('#robo360-config')?.textContent || '{}');
  const model = () => typeof selectedModel !== 'undefined' ? selectedModel : $('#mockup-container')?.dataset.model;
  function profile() {
    const p = profiles[model()], overlay = $('#mockup-overlay');
    if (!p || !overlay?.src) return null;
    // Fail closed if the flat template is replaced without recalibration.
    const filename = decodeURIComponent(new URL(overlay.currentSrc || overlay.src, location.href).pathname.split('/').pop());
    return filename === p.file ? p : null;
  }
  function status(key) {
    const node = $('[data-preview-360-status]');
    if (node) { node.textContent = config().copy?.[key] || ''; node.hidden = !key; }
  }
  function controls() {
    $('[data-preview-flat]')?.setAttribute('aria-pressed', String(mode === 'flat'));
    $('[data-preview-360]')?.setAttribute('aria-pressed', String(mode === '360'));
    const turns = $('[data-preview-360-turns]'); if (turns) turns.hidden = mode !== '360';
    const hint = $('#cz-preview-hint');
    if (hint) {
      if (!hint.dataset.flatHint) hint.dataset.flatHint = hint.textContent;
      hint.textContent = mode === '360' ? config().copy.hint : hint.dataset.flatHint;
    }
  }
  // Only the artwork and its relative print geometry matter. Ignore unrelated
  // coaching classes, status messages and page scroll (all observer noise).
  function signature() {
    const design=$('#design-image'), overlay=$('#mockup-overlay'), clip=$('#mockup-container .design-clip-zone');
    if(!design||!overlay||!clip)return '';
    const dr=design.getBoundingClientRect(), cr=clip.getBoundingClientRect(), box=overlay.getBoundingClientRect();
    const ds=getComputedStyle(design), cs=getComputedStyle(clip);
    const n=value=>Math.round(value*1000)/1000;
    return JSON.stringify([model(),design.currentSrc||design.src,overlay.currentSrc||overlay.src,ds.display,ds.objectFit,cs.clipPath,
      ...[dr.left-box.left,dr.top-box.top,dr.width,dr.height,cr.left-box.left,cr.top-box.top,cr.width,cr.height,box.width,box.height].map(n)]);
  }
  function syncRotationControls(surface, current) {
    if(!current?.getState)return;
    const state=current.getState(), angle=Math.round(state.angle)%360;
    const slider=$('[data-'+surface+'-360-slider]'), output=$('[data-'+surface+'-360-angle]'), toggle=$('[data-'+surface+'-360-auto]');
    if(slider && document.activeElement!==slider)slider.value=String(angle);
    if(slider)slider.setAttribute('aria-valuetext',angle+'°');
    if(output)output.textContent=angle+'°';
    if(toggle){toggle.setAttribute('aria-pressed',String(state.auto));toggle.textContent=state.auto?toggle.dataset.stop:toggle.dataset.start;}
  }
  function bindRotationControls(surface, current) {
    const slider=$('[data-'+surface+'-360-slider]'), toggle=$('[data-'+surface+'-360-auto]');
    if(slider)slider.oninput=()=>{current()?.setAngle(Number(slider.value));syncRotationControls(surface,current());};
    if(toggle)toggle.onclick=()=>{const v=current();if(v){v.setAutoRotate(!v.getState().auto);syncRotationControls(surface,v);}};
  }
  function updateZoom(value) {
    $('[data-preview-zoom]').textContent = Math.round(value * 100) + '%';
    $('[data-preview-out]').disabled = value <= 1;
    $('[data-preview-in]').disabled = value >= 2.5;
  }
  const assets = p => p?.renderer ? config().models?.[p.renderer] : config();
  function loadRenderer(p = profile()) {
    if (!p || !assets(p)?.renderer) return Promise.reject(Error('Unsupported renderer'));
    const key = p.renderer || 'iphone16';
    const factory = () => p.renderer ? window.RoboPixel360Renderers?.[key] : window.RoboPixel360Renderer;
    if (factory()) return Promise.resolve(factory());
    if (!rendererLoads.has(key)) rendererLoads.set(key, new Promise((resolve, reject) => {
      const script = document.createElement('script');
      const timeout = setTimeout(() => { script.remove(); reject(Error('Renderer timeout')); }, 15000);
      script.src = assets(p).renderer;
      script.onload = () => { clearTimeout(timeout); if (factory()) resolve(factory()); else reject(Error('Renderer missing')); };
      script.onerror = () => { clearTimeout(timeout); script.remove(); reject(Error('Renderer load failed')); };
      document.head.appendChild(script);
    }).catch(error => { rendererLoads.delete(key); throw error; }));
    return rendererLoads.get(key);
  }
  function image(src) {
    if (!imageCache.has(src)) {
      const job = new Promise((resolve, reject) => {
        const img = new Image(), timeout = setTimeout(() => reject(Error('Image timeout')), 15000);
        img.crossOrigin = 'anonymous';
        img.onload = () => { clearTimeout(timeout); resolve(img); };
        img.onerror = () => { clearTimeout(timeout); reject(Error('Image cannot be used in 360')); };
        img.src = src;
      }).catch(error => { imageCache.delete(src); throw error; });
      imageCache.set(src, job);
      if (imageCache.size > 4) imageCache.delete(imageCache.keys().next().value);
    }
    return imageCache.get(src);
  }
  // Match object-fit:cover (the editor's policy) without stretching photos.
  function drawPhoto(ctx, img, rect, style) {
    const nw = img.naturalWidth, nh = img.naturalHeight;
    const boxRatio = rect.width / rect.height, imageRatio = nw / nh;
    if (style.objectFit === 'cover') {
      const sw = imageRatio > boxRatio ? nh * boxRatio : nw;
      const sh = imageRatio > boxRatio ? nh : nw / boxRatio;
      ctx.drawImage(img, (nw-sw)/2, (nh-sh)/2, sw, sh, rect.left, rect.top, rect.width, rect.height);
    } else ctx.drawImage(img, rect.left, rect.top, rect.width, rect.height);
  }
  async function artwork(p, ticket) {
    const design = $('#design-image'), overlay = $('#mockup-overlay');
    const src = design.currentSrc || design.src;
    if (!src || getComputedStyle(design).display === 'none') throw Error('No design');
    const [img] = await Promise.all([image(src), overlay.decode()]);
    if ((ticket !== null && ticket !== revision) || src !== (design.currentSrc || design.src)) return null;
    // Shopify serves proportional CDN renditions (e.g. 800×1600) of the
    // calibrated 1200×2400 PNG. The canonical bounds remain unchanged.
    if (!overlay.naturalWidth || Math.abs(overlay.naturalHeight / overlay.naturalWidth - 2) > .001) throw Error('Uncalibrated template');
    const box = overlay.getBoundingClientRect(), clip = $('#mockup-container .design-clip-zone');
    const cr = clip.getBoundingClientRect(), dr = design.getBoundingClientRect();
    const cs = getComputedStyle(clip), ds = getComputedStyle(design);
    // The overlay is object-fit:contain. Account for any letterboxing too.
    const fit = Math.min(box.width / 1200, box.height / 2400);
    if (!fit || !dr.width || !dr.height) throw Error('Hidden editor');
    const ox = box.left + (box.width - 1200 * fit)/2;
    const oy = box.top + (box.height - 2400 * fit)/2;
    // Keep the exact visible flat-template crop; never reveal hidden artwork
    // to compensate for a different 3D panel aspect ratio.
    const [x0,y0,x1,y1] = p.panel, pw=x1-x0, ph=y1-y0;
    const result = document.createElement('canvas');
    result.height = 2048; result.width = Math.round(2048 * pw / ph);
    const ctx = result.getContext('2d');
    ctx.fillStyle = '#fff'; ctx.fillRect(0,0,result.width,result.height);
    ctx.scale(result.width / (pw * fit), result.height / (ph * fit));
    ctx.translate(-ox-x0*fit, -oy-y0*fit);
    // Existing editor uses inset(0 round <px>) in addition to rectangular overflow.
    // Refuse new unsupported clip shapes rather than silently shifting a design.
    if (cs.clipPath !== 'none' && !/^inset\(0px(?: 0px){0,3} round [\d.]+px\)$/.test(cs.clipPath)) throw Error('Unsupported clip shape');
    const match = cs.clipPath.match(/round ([\d.]+)px/);
    const radius = match ? Number(match[1]) : parseFloat(cs.borderRadius) || 0;
    ctx.beginPath(); ctx.roundRect(cr.left,cr.top,cr.width,cr.height,radius); ctx.clip();
    drawPhoto(ctx,img,dr,ds);
    // Verify origin-clean before handing the canvas to WebGL; no raster export.
    ctx.getImageData(0,0,1,1);
    return result;
  }
  function toFlat() {
    wanted = false; revision++; mode = 'flat'; lastSignature=null; clearTimeout(timer);
    if (canvas) canvas.hidden = true;
    if (flat) flat.hidden = false;
    viewer?.setActive(false); controls(); status('');
    window.RoboPixelPreview?.refresh();
    window.RoboPixelPreview?.reset();
  }
  async function show360() {
    const p = profile(); if (!opened || !p) { toFlat(); return; }
    wanted = true; const ticket = ++revision;
    const entering=mode!=='360';
    if(entering)status('loading');
    lastSignature=signature();
    try {
      const [texture, renderer] = await Promise.all([artwork(p,ticket), loadRenderer(p)]);
      if (!texture || ticket !== revision || !opened || p !== profile()) return;
      if (viewer && viewerProfile !== p) { viewer.dispose(); viewer=null; canvas?.remove(); canvas=null; }
      if (!viewer) {
        const target = document.createElement('canvas'); target.className = 'cz-preview-360-canvas';
        target.tabIndex = 0; target.setAttribute('aria-label', config().copy.hint);
        target.addEventListener('contextmenu', e => e.preventDefault());
        target.addEventListener('robopixel:360-change', () => syncRotationControls('preview',viewer));
        target.addEventListener('robopixel:360-error', () => { toFlat(); viewer?.dispose(); viewer=null; target.remove(); canvas=null; status('error'); });
        const candidate = await renderer.create(target, assets(p).photos);
        if (ticket !== revision || !opened || p !== profile()) { candidate.dispose(); return; }
        viewer = candidate; viewerProfile = p; canvas = target; stage.appendChild(canvas);
      }
      viewer.setArtwork(texture); canvas.hidden = false; flat.hidden = true;
      mode = '360'; viewer.setActive(true); controls(); updateZoom(viewer.getState().zoom); status('');
      if(entering)viewer.setAutoRotate?.(!window.matchMedia?.('(prefers-reduced-motion: reduce)').matches);
      syncRotationControls('preview',viewer);lastSignature=signature();
      canvas.dataset.model = model(); canvas.dataset.profile = 'print-panel-v1';
    } catch (error) {
      if (ticket !== revision || !opened) return;
      toFlat(); status('error'); console.warn('[RoboPixel 360]', error.message);
    }
  }
  function schedule() {
    if (!opened) return;
    const supported = !!profile(); $('[data-preview-modes]').hidden = !supported;
    if (model() !== lastModel) { lastModel = model(); toFlat(); return; }
    if (!supported) { toFlat(); return; }
    if (!wanted) { window.RoboPixelPreview?.refresh(); return; }
    if(lastSignature!==null && signature()===lastSignature)return;
    revision++; clearTimeout(timer); timer = setTimeout(show360, 100);
  }
  function attach(target, snapshot) {
    opened = true; stage = target; flat = snapshot; lastModel = model();
    const nav = $('[data-preview-modes]'); if (!nav) return;
    nav.hidden = !profile(); $('[data-preview-flat]').onclick = toFlat;
    $('[data-preview-360]').onclick = show360;
    bindRotationControls('preview',()=>viewer);
    if (canvas) { stage.appendChild(canvas); canvas.hidden = true; }
    mode = 'flat'; wanted = false; controls(); status('');
    observer?.disconnect(); resizeObserver?.disconnect();
    observer = new MutationObserver(schedule);
    observer.observe($('#mockup-container'), {attributes:true,subtree:true,attributeFilter:['src','srcset','style','class','data-model']});
    resizeObserver = new ResizeObserver(schedule); resizeObserver.observe($('#mockup-container'));
    $('#design-image').addEventListener('load', schedule);
    $('#mockup-overlay').addEventListener('load', schedule);
  }
  function close() {
    opened = false; wanted = false; revision++; clearTimeout(timer); mode = 'flat';
    observer?.disconnect(); resizeObserver?.disconnect(); viewer?.setActive(false);
    $('#design-image')?.removeEventListener('load', schedule);
    $('#mockup-overlay')?.removeEventListener('load', schedule);
    controls(); status('');
  }
  window.addEventListener('pagehide', () => { close(); viewer?.dispose(); viewer=null; canvas=null; imageCache.clear(); });
  window.RoboPixel360 = {
    transfer: {
      profile, loadRenderer, config, assets, signature, syncRotationControls, bindRotationControls,
      async capture() {
        const p = profile(); if (!p) throw Error('Unsupported model');
        const design = $('#design-image');
        if (!design?.getAttribute('src') || getComputedStyle(design).display === 'none') {
          const blank = document.createElement('canvas'); blank.width=2; blank.height=2;
          const ctx=blank.getContext('2d'); ctx.fillStyle='#fff'; ctx.fillRect(0,0,2,2); return blank;
        }
        return artwork(p, null);
      }
    },
    attach, close, isActive: () => mode === '360',
    rotateBy(delta) { if(mode==='360')viewer?.rotateBy?.(delta); },
    zoomBy(delta) { if(mode!=='360')return false; updateZoom(viewer.zoomBy(delta)); return true; },
    reset() { if(mode!=='360')return false; updateZoom(viewer.reset()); return true; }
  };
})();
